/**
 * Единая точка работы с токеном сессии для ВСЕХ axios-интерцепторов
 * (core `reactQuery.ts`, `config.ts`, `utils/index.ts`, нотариат `notary/reactQuery.ts`).
 *
 * ЗАЧЕМ ДОБАВЛЕНО (OSI-796):
 * 1. Request-интерцепторы ставили заголовок `Bearer ${token || ''}` безусловно. Если токена нет
 *    (пользователь просто открыл вкладку), на бэк уходило буквально «Bearer » — заведомо невалидный
 *    заголовок, гарантированный 401.
 * 2. Response-интерцепторы на 401 показывали тост «Сессия истекла» тоже безусловно. Но 401 при
 *    ОТСУТСТВУЮЩЕМ токене означает «пользователь не авторизован», а НЕ «сессия протухла» —
 *    неавторизованный пользователь видел ложный тост сразу после открытия страницы.
 *
 * Поэтому интерцепторы должны отличать «сессии не было» от «сессия была и протухла».
 */

/**
 * Ключ токена основного API (core + doc-service).
 * ВАЖНО: `authModule.sessionExpired()`/`logout()` кладут сюда ПУСТУЮ СТРОКУ, а не удаляют ключ,
 * поэтому «нет сессии» — это и `null` (ключа не было), и `''` (сессию уже сбросили).
 */
export const TOKEN_STORAGE_KEY = 'token';

/** Ключ токена сервиса нотариата — отдельная сессия со своим хранилищем. */
export const NOTARY_TOKEN_STORAGE_KEY = 'notary:token';

/**
 * Возвращает токен сессии или пустую строку, если сессии нет.
 * @param key ключ в localStorage (по умолчанию — токен основного API).
 */
export const getSessionToken = (key: string = TOKEN_STORAGE_KEY): string => localStorage.getItem(key) || '';

/**
 * Существовала ли сессия на момент вызова.
 * Только если `true`, полученный 401 действительно означает «сессия истекла».
 */
export const hasSessionToken = (key: string = TOKEN_STORAGE_KEY): boolean => Boolean(getSessionToken(key));
